import { Faq } from '@/types/common'

export const faqs: Faq[] = [
  {
    question: '持ち込み商品への印刷を依頼することはできますか？',
    answer:
      `ご対応いたしかねます。<br>
      お持ち込み商品への印刷加工は、加工の保証や商品の弁償をいたしかねるため承っておりません。`
  },
  {
    question: 'サンプルを借りることはできますか？',
    answer:
      `誠に恐れ入りますが、無料サンプルの貸し出しはお承りしておりません。<br>
      「印刷なし」の商品も1枚からご購入可能でございますので是非ご検討ください。`
  },
  {
    question: '注文からどれくらいの日数で商品が届きますか？',
    answer:
      `通常、印刷ありの商品はご注文からお届けまで2週間ほどお時間をいただいておりますが、当日・翌日出荷対応の商品のお取り扱いもございます。<br>
      出荷日、納品日の詳細はご希望の商品ページにてご確認ください。`
  },
  {
    question: '見積りの算出方法を教えてください',
    answer:
      `サイト上で見積りの算出が可能です。<br>
      ご希望の商品ページにて「数量・印刷方法・印刷箇所」をご選択いただければ<br>
      見積りと最短出荷日が表示されます。<br>
      ※見積書の発行方法は<a href="https://guide.raksul.com/hc/ja/articles/4447312526863">こちら</a>もご参照ください。`
  },
  {
    question: 'オンスとはどのような意味ですか？',
    answer:
      `服の厚みの目安となる数値となります。<br>
      数字が高いほど生地の厚みが増し、逆に数字が低いほど薄手のさらっとした着心地となります。<br>
      Tシャツの定番は5.6オンスとなりますのでご参考にしてください。`
  }
]
